"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryRulesEditor = void 0;
const lodash_1 = __importDefault(require("lodash"));
const DeliveryRule_1 = require("./DeliveryRule");
const DeliveryRulesBase_1 = require("./DeliveryRulesBase");
const PickAndPackRule_1 = require("./PickAndPackRule");
class DeliveryRulesEditor extends DeliveryRulesBase_1.DeliveryRulesBase {
    constructor(deliveryRules) {
        super(deliveryRules);
    }
    removeDeliveryRule(region, key) {
        if (!this.deliveryRulesByRegion[region]) {
            return;
        }
        delete this.deliveryRulesByRegion[region][key];
        if (!this.deliveryRulesByKey[key]) {
            return;
        }
        this.deliveryRulesByKey[key] = this.deliveryRulesByKey[key].filter((deliveryRule) => {
            return deliveryRule.getRegion() !== region;
        });
    }
    removePickAndPackRule(key) {
        const existingRule = this.blockedPickAndPackDatesManager.get(key);
        if (existingRule) {
            this.blockedPickAndPackDatesManager.remove(existingRule);
        }
    }
    getOrCreateDeliveryRuleWithRegionAndWeekday(region, key) {
        const result = this.getRuleWithRegionAndKey(region, key);
        if (result) {
            return result;
        }
        this.addDeliveryRuleForWeekDay(key, '12:00', 1, false, region);
        return this.getRuleWithRegionAndKey(region, key);
    }
    getOrCreateDeliveryRuleWithRegionAndDate(region, key) {
        const result = this.getRuleWithRegionAndKey(region, key);
        if (result) {
            return result;
        }
        this.addDeliveryRuleForDate(key, '12:00', 1, false, region);
        return this.getRuleWithRegionAndKey(region, key);
    }
    getBlockedPickAndPackDatesManager(key) {
        return this.blockedPickAndPackDatesManager.get(key);
    }
    createOrRemovePickAndPackRule(key, blocked) {
        const existingRule = this.blockedPickAndPackDatesManager.get(key);
        if (blocked && existingRule) {
            return;
        }
        if (!blocked && existingRule) {
            this.blockedPickAndPackDatesManager.remove(existingRule);
            return;
        }
        if (blocked && !existingRule) {
            this.blockedPickAndPackDatesManager.add(PickAndPackRule_1.PickAndPackRule.pickAndPackRuleFromProps({ date: key }));
            return;
        }
        if (!blocked && !existingRule) {
            return;
        }
    }
    getRuleWithRegionAndKey(region, key) {
        return this.deliveryRulesByRegion[region]?.[key]?.[0];
    }
    getBlockedPickAndPackRuleWithDate(date) {
        return this.blockedPickAndPackDatesManager.get(date);
    }
    addDeliveryRule(deliveryRule) {
        const rawRules = this.getRawDeliveryRules() || [];
        this.initializeRules([...rawRules, deliveryRule.getDefinition()]);
    }
    setRules(deliveryRules) {
        this.initializeRules(deliveryRules ?? []);
    }
    getRulesWithRegion(region) {
        return Object.values(this.deliveryRulesByRegion[region] ?? []).flat();
    }
    getDeliveryRuleDefinitions() {
        const rules = [
            ...Object.values(this.deliveryRulesByKey).flat(),
            ...this.blockedPickAndPackDatesManager.getAllRules(),
        ];
        if (!rules || rules.length === 0) {
            return null;
        }
        return (0, lodash_1.default)(rules)
            .map((rule) => rule.exportAsDeliveryRuleDefinition())
            .uniqWith(lodash_1.default.isEqual)
            .value();
    }
    getUniqueRegions() {
        return Object.keys(this.deliveryRulesByRegion);
    }
    changeRegion(oldRegion, newRegion) {
        if (oldRegion === newRegion) {
            return;
        }
        if (this.deliveryRulesByRegion && this.deliveryRulesByRegion[oldRegion]) {
            for (const key of Object.keys(this.deliveryRulesByRegion[oldRegion])) {
                if (this.deliveryRulesByRegion[oldRegion] &&
                    this.deliveryRulesByRegion[oldRegion][key]) {
                    for (const rule of this.deliveryRulesByRegion[oldRegion][key]) {
                        rule.setRegion(newRegion);
                    }
                }
            }
        }
        const rules = this.deliveryRulesByRegion[oldRegion];
        delete this.deliveryRulesByRegion[oldRegion];
        if (rules) {
            this.deliveryRulesByRegion[newRegion] = rules;
        }
    }
    // Delivery rules manipulation
    addDeliveryRuleForWeekDay(deliveryWeekDay, orderByTime, orderDaysBefore, blocked, region) {
        const deliveryRule = DeliveryRule_1.DeliveryRule.deliveryRuleFromProps({
            region,
            deliveryWeekDay,
            orderByTime,
            orderDaysBefore,
            blocked,
        });
        this.addDeliveryRule(deliveryRule);
    }
    addDeliveryRuleForDate(date, orderByTime, orderDaysBefore, blocked, region) {
        const deliveryRule = DeliveryRule_1.DeliveryRule.deliveryRuleFromProps({
            region,
            date,
            orderByTime,
            orderDaysBefore,
            blocked,
        });
        this.addDeliveryRule(deliveryRule);
    }
}
exports.DeliveryRulesEditor = DeliveryRulesEditor;
